import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import '../profile.css';
import './seller-support.css';
import SellerSupportForm from './SellerSupportForm';
import SellerSupportList from './SellerSupportList';
import { useLocation, NavLink } from 'react-router-dom';
import RaiseDisputeForm from './RaiseDisputeForm';
import DisputeList from './DisputeList';


function SellerSupport() {

    const [tab, setTab] = useState("raise-ticket");

    return (
        <div className='seller-support-page'>
            <Card className="m-1 card-box text-dark p-2">
            <div className="new-tabs d-flex bb-2">
                    <div className={`tabs cursor-pointer ${tab==="raise-ticket"?'active':''}`} onClick={() => setTab("raise-ticket")}>
                            Raise a Ticket
                    </div>
                        <div className={`tabs cursor-pointer ${tab==="check-status"?'active':''}`} onClick={() => setTab("check-status")}>
                                Check Ticket Status
                        </div>
                        <div className={`tabs cursor-pointer ${tab==="raise-dispute"?'active':''}`} onClick={() => setTab("raise-dispute")}>
                                Raise a Dispute
                        </div>
                        <div className={`tabs cursor-pointer ${tab==="check-dispute-status"?'active':''}`} onClick={() => setTab("check-dispute-status")}>
                                Check Dispute Status
                        </div>
            </div>
                {/* <div className='seller-support-page__header'>
                    <div className='seller-support-page__links'>
                        <div className={`seller-support-page__link ${tab ? 'seller-support-page__link--active' : ''}`} onClick={() => setTab(true)}>
                            <i className="bi bi-plus-square-fill me-1" /> Raise a Ticket
                        </div>
                        <div className={`seller-support-page__link ms-4 ${!tab ? 'seller-support-page__link--active' : ''}`} onClick={() => setTab(false)}>
                            <i class="bi bi-filter-square-fill me-1" /> Check Ticket Status
                        </div>
                    </div>
                </div> */}
                <div className='bank-account'>
                    {
                        tab === "raise-ticket" && 
                            <>
                                 <div className='title'>
                                    Submit a ticket
                                </div>
                                 <SellerSupportForm />
                            </>
                    }
                    {
                        tab === "check-status" && 
                            <SellerSupportList />
                    }
                    {
                        tab === "raise-dispute" && 
                            <RaiseDisputeForm />
                    }
                    {
                        tab === "check-dispute-status" && 
                            <DisputeList />
                    }
                </div>
            </Card>

            <div className='seller-support-contact-section'>
                <div className='contact-header'>
                    <h4 className='contact-title'>Get in Touch</h4>
                    <p className='contact-subtitle'>We are here to help you</p>
                </div>
                <div className='contact-methods'>
                    <div className='contact-card email-card'>
                        <div className='contact-icon'>
                            <i className="bi bi-envelope-fill"></i>
                        </div>
                        <div className='contact-info'>
                            <h6 className='contact-label'>Email Support</h6>
                            <a href="mailto:sellersupport@toolsvilla.com" className='contact-value'>
                                sellersupport@toolsvilla.com
                            </a>
                        </div>
                    </div>
                    <div className='contact-card phone-card'>
                        <div className='contact-icon'>
                            <i className="bi bi-telephone-fill"></i>
                        </div>
                        <div className='contact-info'>
                            <h6 className='contact-label'>Phone Support</h6>
                            <a href="tel:+919986646883" className='contact-value'>
                                +91 998-664-6883
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )



}




export default SellerSupport;